// import { initializeStylescape } from 'stylescape';
import { CustomCursor } from "./CustomCursor";
// import { HeroScrollAnimator } from './HeroScrollAnimator';
import { SpreadFolioObserver } from './SpreadFolioObserver';
import { WorkRandomOffset } from "./WorkRandomOffset";


document.addEventListener('DOMContentLoaded', () => {
        // new HeroScrollAnimator();
    new CustomCursor();
    new SpreadFolioObserver();
    new WorkRandomOffset();

});

// initializeStylescape();
